// @flow

export const getLinkIdFromUrl = (isBackOffice: boolean):string => {
  let linkId = location.search.match(/linkId=(.+?)(?:&|$)/i)
  if (linkId && isBackOffice) {
    const sessionLinkId = sessionStorage.getItem('linkId')
    if (!sessionLinkId || sessionLinkId !== linkId[1]) {
      sessionStorage.setItem('linkId', linkId[1])
      return linkId[1]
    }
  }
  return ''
}
